module.exports = __webpack_public_path__ + "static/media/Decoration.2290784e.svg";